import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import UserPermissions from '@/ui/pages/UserPermissions/UserPermissions';

export const Route = createFileRoute('/_dashboard/users/$id/$tenantId/permissions')({
  beforeLoad: requireRoute('/users/$id/$tenantId/permissions'),
  component: UserPermissions,
});
